import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store";
import { getCurrencyConfiguration } from "@src/store/slices/organization/selectors/getCurrencyConfiguration";

export const getExperienceCurrencyFormat = createSelector(
  (state: RootState) => state.experience.experience?.currency?.code,
  getCurrencyConfiguration,
  (code, configuration) =>
    new Intl.NumberFormat(configuration?.locale || "en-US", {
      style: "currency",
      currency: code || configuration?.code || "USD",
      minimumFractionDigits: 2,
    })
);
